// App Reducers
import { connectRouter } from 'connected-react-router';
import { persistCombineReducers } from 'redux-persist';
import storage from 'redux-persist/es/storage';

import { immutableReconciler, immutableTransform } from '../libs/immutable-transformer';
import accessVouchers from './accessVouchers/reducer';
import auth from './auth/reducer';
import cateringOptions from './cateringOptions/reducer';
import companies from './companies/reducer';
import crewMaterialTemplates from './crewMaterialTemplates/reducer';
import crewMaterials from './crewMaterials/reducer';
import crewMembers from './crewMembers/reducer';
import departments from './departments/reducer';
import emailTemplateTypes from './emailTemplateTypes/reducer';
import emailTemplates from './emailTemplates/reducer';
import eventMaterials from './eventMaterials/reducer';
import events from './events/reducer';
import gates from './gates/reducer';
import groups from './groups/reducer';
import locations from './locations/reducer';
import materialCategories from './materialCategories/reducer';
import materials from './materials/reducer';
import media from './media/reducer';
import occupations from './occupations/reducer';
import parkingVouchers from './parkingVouchers/reducer';
import parkings from './parkings/reducer';
import periods from './periods/reducer';
import permissions from './permissions/reducer';
import preferences from './preferences/reducer';
import printers from './printers/reducer';
import profileGroups from './profileGroups/reducer';
import profiles from './profiles/reducer';
import registrations from './registrations/reducer';
import rentals from './rentals/reducer';
import safetyQuestions from './safetyQuestions/reducer';
import system from './system/reducer';
import transportVouchers from './transportVouchers/reducer';
import users from './users/reducer';
import venues from './venues/reducer';
import wristbands from './wristbands/reducer';
import zones from './zones/reducer';

const config = {
  transforms: [immutableTransform],
  key: 'root',
  storage,
  stateReconciler: immutableReconciler,
  whitelist: ['preferences', 'printers'],
  debug: true,
};

export const createRootReducer = (history) =>
  persistCombineReducers(config, {
    router: connectRouter(history),
    auth,
    system,
    groups,
    users,
    permissions,
    venues,
    zones,
    events,
    periods,
    companies,
    preferences,
    media,
    accessVouchers,
    parkingVouchers,
    transportVouchers,
    profiles,
    profileGroups,
    parkings,
    occupations,
    cateringOptions,
    materials,
    materialCategories,
    eventMaterials,
    safetyQuestions,
    emailTemplates,
    emailTemplateTypes,
    crewMaterials,
    crewMaterialTemplates,
    registrations,
    departments,
    crewMembers,
    gates,
    locations,
    rentals,
    printers,
    wristbands,
  });
